<template>
  <v-container class="grey lighten-5">
    <v-row no-gutters style="height: 150px;">
      <v-col>
        <v-card class="pa-2 ma-3" outlined tile>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Username </th>
                  <th class="text-left">
                    Role </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in listOfUsers" :key="item.login">
                  <td>{{ item.login }}</td>
                  <td>{{ item.role }}</td>
                  <td>
                    <v-select :items="['ADMIN', 'USER', 'ITSO']" v-model="item.role" dense hide-details outlined class="w-50" @change="item.hasChanged = true"></v-select>
                  </td>
                  <td>
                    <v-btn icon color="primary" :disabled="!item.hasChanged || item.role === item.originalRole" @click="updateUserRole(item)">
                      <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-card>
      </v-col>
      <v-col>
        <v-card class="pa-2 ma-3" outlined tile>
          <v-container>
            <h1>CREATE USER</h1>
            <v-text-field label="Username" v-model="creatingUsername"></v-text-field>
            <v-text-field label="Password" v-model="creatingUserPassword"></v-text-field>

            <v-radio-group class="ma-5" v-model="radioGroup" @change="selectionChange()">
              <v-radio v-for="role in rolesTypes" :key="role" :label="role" :value="role"></v-radio>
            </v-radio-group>
            <v-btn color="success" @click="createUser"> CREATE</v-btn>

          </v-container>

        </v-card>
      </v-col>


      <v-col>
        <v-card class="pa-2 ma-3" outlined tile>


          <v-container>
            <h1>DELETE USER</h1>
            <v-text-field label="Username" v-model="deletingUsername"></v-text-field>
            <v-btn color="error" @click="deleteUser"> DELETE</v-btn>

          </v-container>

        </v-card>
      </v-col>



    </v-row>
  </v-container>
</template>

<script>

  let rolesTypes={
    USER : 'USER', 
    ADMIN : 'ADMIN', 
    EXTRANET: 'EXTRANET'
  };

import {getUsers, createUser, deleteUser, updateUser} from "@/services/RequestService";
import { store } from "@/models/Store.js";
export default {
    async created(){
      const users = await getUsers();
      this.listOfUsers = users.map(user => ({
      ...user,
      hasChanged: false,
      originalRole: user.role
    }))
        //this.listOfUsers = await getUsers();
        //console.log(this.listOfUsers)
    },
    data: ()=>{
        return {
            userInCreationRole: null,
            radioGroup: null, 
            listOfUsers : null,
            rolesTypes : rolesTypes,
            creatingUsername: null,
            creatingUserPassword : null,
            deletingUsername: null,
            store: store,

        }
    },
methods:{
    selectionChange: function(){
        this.userInCreationRole = rolesTypes[this.radioGroup];
        //console.log(this.userInCreationRole)
    }, 

    async updateUserRole(item) {
      await updateUser(item);
      this.$set(item, 'hasChanged', false);
      this.$set(item, 'originalRole', item.role);
    },

    async deleteUser(){
        await deleteUser(this.deletingUsername);
        //console.log(this.deletingUsername);
        this.refreshUsers();

    },

    async createUser(){
        //console.log(this.creatingUsername);
        await createUser(this.creatingUsername, this.creatingUserPassword, this.userInCreationRole);
        this.refreshUsers();
    },

    async refreshUsers(){
        this.listOfUsers = await getUsers();
    }
}

    
}
</script>

<style>

</style>